import { render, staticRenderFns } from "./UpdateUserEmail.vue?vue&type=template&id=08af9c89&scoped=true&"
import script from "./UpdateUserEmail.vue?vue&type=script&lang=js&"
export * from "./UpdateUserEmail.vue?vue&type=script&lang=js&"
import style0 from "./UpdateUserEmail.vue?vue&type=style&index=0&id=08af9c89&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08af9c89",
  null
  
)

export default component.exports